import { render, staticRenderFns } from "./field-checkbox.vue?vue&type=template&id=bbf43644"
import script from "./field-checkbox.vue?vue&type=script&lang=js"
export * from "./field-checkbox.vue?vue&type=script&lang=js"
import style0 from "./field-checkbox.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports